import { createReducer } from '@reduxjs/toolkit';

import getCalculateReport from '../../thunks/calculateReport/getCalculateReport';

const initialState = {
  loading: false,
  error: '',
  data: undefined,
};

const getCalculateReportReducer = createReducer(initialState, {
  [getCalculateReport.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getCalculateReport.fulfilled]: (state, { payload: { data } }) => ({
    ...state,
    loading: false,
    data,
  }),
  [getCalculateReport.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getCalculateReportReducer;
